// extracted by mini-css-extract-plugin
var _1 = "select__ifZLX";
export { _1 as "select" }
